import { useState } from 'react';
import type { CreateClaimPayload } from '../types/LegalCase';

interface UseLegalCaseClaimFormArgs {
    createClaim: (data: CreateClaimPayload) => Promise<boolean>;
    clearErrors: () => void;
}

// Estado e handlers do form de criação de pretensão + o toggle do form de item. Extraído do
// componente (diretriz do repo: sem função dentro de função; padrão do useLegalCasePartyForm da
// Task 3). Centraliza o reset dos campos: abrir/cancelar/criar com sucesso sempre zera, então
// valores digitados numa tentativa anterior não vazam para a próxima.
export default function useLegalCaseClaimForm({ createClaim, clearErrors }: UseLegalCaseClaimFormArgs) {
    const [showItemForm, setShowItemForm] = useState(false);
    const [creating, setCreating] = useState(false);
    const [principal, setPrincipal] = useState(0);
    const [interest, setInterest] = useState(0);
    const [penalties, setPenalties] = useState(0);
    const [legalCosts, setLegalCosts] = useState(0);
    const [description, setDescription] = useState('');

    const resetFields = () => {
        setPrincipal(0);
        setInterest(0);
        setPenalties(0);
        setLegalCosts(0);
        setDescription('');
    };

    const openCreate = () => {
        clearErrors();
        resetFields();
        setCreating(true);
    };

    const cancelCreate = () => {
        clearErrors();
        resetFields();
        setCreating(false);
    };

    const submitCreate = async () => {
        const ok = await createClaim({
            principal: principal > 0 ? principal : undefined,
            interest: interest > 0 ? interest : undefined,
            penalties: penalties > 0 ? penalties : undefined,
            legalCosts: legalCosts > 0 ? legalCosts : undefined,
            description: description.trim() || undefined,
        });
        if (ok) {
            resetFields();
            setCreating(false);
        }
    };

    const openItemForm = () => {
        clearErrors();
        setShowItemForm(true);
    };

    const closeItemForm = () => {
        clearErrors();
        setShowItemForm(false);
    };

    return {
        // form de criação
        creating, openCreate, cancelCreate, submitCreate,
        principal, setPrincipal,
        interest, setInterest,
        penalties, setPenalties,
        legalCosts, setLegalCosts,
        description, setDescription,
        // form de item
        showItemForm, openItemForm, closeItemForm,
    };
}
